import React from 'react';
import JobAlertsManagement from './JobAlertsManagement';

// Thin wrapper to expose Job Alerts Management under a new route/name
export default function JAlertsMngmt() {
  return <JobAlertsManagement />;
}
